import { API_CONFIG } from '../../config/api';
import { getToken } from '../tokenStorage';

export interface SourceBreakdown {
  source: string;
  total_cost_usd: number;
  total_credits: number;
  call_count: number;
}

export interface UsageSummary {
  window_days: number;
  since: string;
  total_cost_usd: number;
  total_credits: number;
  call_count: number;
  breakdown: SourceBreakdown[];
}

async function authHeaders() {
  const token = await getToken();
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
}

export async function getUsage(days = 30): Promise<UsageSummary> {
  const url = new URL(`${API_CONFIG.baseURL}/api/v1/usage`);
  url.searchParams.append('days', String(days));
  const res = await fetch(url.toString(), { method: 'GET', headers: await authHeaders() });
  if (!res.ok) throw new Error('Failed to fetch usage');
  return res.json();
}
